import axios from 'axios';

export function getAccountById(id: number) {
  return axios.get(`/api/v2/reports/accounts/${id}`);
}
